import { type FC } from "react";
import { Navigate, useParams } from "react-router";
import { useGetOrganisationHierarchy } from "../../../api/organisations";
import { PageSpinner } from "../../../shared/Page";
import { SettingsPageLayout } from "../shared/SettingsPageLayout";
import { OrganisationTree } from "../shared/OrganisationTree";
import { OrganisationUnitUsers } from "./OrganisationUnitUsers";

export const OrganisationUnits: FC = () => {
  const { data } = useGetOrganisationHierarchy();
  const params = useParams();

  if (!data) return <PageSpinner />;

  const fallbackTenantId = data.id;

  if (!params.tenantId) return <Navigate to={fallbackTenantId} replace />;
  return (
    <SettingsPageLayout
      sidebarContent={<OrganisationTree organisationHierarchy={data} />}
      mainContent={<OrganisationUnitUsers rootId={data.id} />}
    />
  );
};
